import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaUserAlt, FaCalendarAlt, FaTag } from "react-icons/fa";
import blogApi from '../../api/Blogapi';
import { useParams } from "react-router";

const BlogDetail = () => {
  const { slug  } = useParams();
  const [blog, setBlog] = useState(null);

 useEffect(() => {
  blogApi.getBySlug(slug)
    .then((res) => setBlog(res))
    .catch((err) => console.error(err));
}, [slug]);

  if(!blog) return <p>Blog Loading ... </p>

  return (
    <div className="blog-detail-page">
      {/* ===== Page Banner ===== */}
      <Container fluid className="Main-background" style={{ height: "25rem" }}>
       <div
        className="bg-image"
        style={{
          backgroundImage: `url(${blog?.featured_image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "400px",
        }}
        ></div>
        <div className="overlay"></div>

        <Container>
          <Row>
            <Col lg={12} className="page-top-content text-center">
              <h1 className="page-title">
                {blog.title}
              </h1>
            </Col>
          </Row>
        </Container>
      </Container>

      {/* ===== Blog Content ===== */}
      <Container className="blog-content-section py-5">
        <Row className="justify-content-center">
          <Col lg={12} md={10}>
            <div className="blog-detail-wrapper">
              <p className="lead-text">
                
                 <div dangerouslySetInnerHTML={{ __html: blog.description }}></div>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BlogDetail;
